import type { Campaign } from '@ms/yammer-data/dist/state/types';

import type { GetBaseUrlProps } from '../location/getBaseUrl';
import { getBaseUrl } from '../location/getBaseUrl';

import { insightsCampaignPageWithCampaignId } from './insights';

type CampaignUrl = (id: Campaign['id']) => string;
export const campaignUrl: CampaignUrl = (campaignId) => `/campaigns/${campaignId}`;

export const campaignInsightsPage = '/campaigns/:campaignId/insights';
export const campaignInsightsUrl: CampaignUrl = (campaignId) => `${campaignUrl(campaignId)}/insights`;

export const getCampaignInsightsDestination = ({
  campaignId,
  isGroupCampaign,
  campaignSettings,
}: {
  readonly campaignId: Campaign['id'];
  readonly isGroupCampaign: boolean;
  readonly campaignSettings?: { readonly viewerCanAccessCampaignActivity?: boolean | null } | null;
}): string =>
  isGroupCampaign && campaignSettings?.viewerCanAccessCampaignActivity === false
    ? campaignInsightsUrl(campaignId)
    : insightsCampaignPageWithCampaignId(campaignId);

type CampaignFullUrl = (groupId: Campaign['id'], host: GetBaseUrlProps['host']) => string;
export const campaignFullUrl: CampaignFullUrl = (groupId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${campaignUrl(groupId)}`;
};
